import { render, staticRenderFns } from "./DetailPriceHome.vue?vue&type=template&id=c20c3d92&scoped=true"
import script from "./DetailPriceHome.vue?vue&type=script&lang=js"
export * from "./DetailPriceHome.vue?vue&type=script&lang=js"
import style0 from "./DetailPriceHome.vue?vue&type=style&index=0&id=c20c3d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20c3d92",
  null
  
)

export default component.exports